import { Button, TableColumnsType } from 'antd';
import {
	ApplicationsFilter,
	FunctionaryInfo,
} from '../../../shared/VolunteerApplicationServiceTypes';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { EDIT_FUNCTIONARY } from '../../../shared/Routes';
import { NavigateOptions } from 'react-router-dom';

interface FunctionaryTableColumnsProps {
	navigateWithFunctionarySrcmId: (
		route: string,
		functionarySIdParam?: string,
		params?: NavigateOptions
	) => void;
	onFilterChange: (filterParam: ApplicationsFilter) => void;
}

export const FunctionaryTableColumns = ({
	navigateWithFunctionarySrcmId,
	onFilterChange,
}: FunctionaryTableColumnsProps): TableColumnsType<FunctionaryInfo> => {
	const handleEditProposerClick = useCallback(
		(functionary: FunctionaryInfo) => {
			navigateWithFunctionarySrcmId(EDIT_FUNCTIONARY, functionary.srcmId, {
				state: { from: 'Edit Functionary/Proposer' },
			});
			onFilterChange({ status: ['FUNCTIONARY_ASSIGNED'] });
		},
		[navigateWithFunctionarySrcmId, onFilterChange]
	);
	const { t } = useTranslation();

	return [
		{
			title: t('name'),
			dataIndex: 'printName',
			key: 'printName',
			className:
				'max-w-[400px] border-r-0 whitespace-nowrap md:whitespace-normal break-words',
		},
		{
			title: t('email'),
			dataIndex: 'email',
			key: 'email',
		},
		{
			title: t('gender'),
			dataIndex: 'gender',
			key: 'gender',
			render: (__, record, index) => (
				<span key={index}>
					<span className="ml-2">
						{record?.gender
							? record.gender.charAt(0).toUpperCase() +
							  record.gender.slice(1).toLowerCase()
							: ''}
					</span>
				</span>
			),
		},
		{
			title: t('mobile'),
			dataIndex: 'mobile',
			key: 'mobile',
			className: 'whitespace-nowrap',
		},
		{
			title: t('SRCMID'),
			dataIndex: 'srcmId',
			key: 'srcmId',
			className: 'whitespace-nowrap',
		},
		{
			title: t('homeZone'),
			dataIndex: 'homeZone',
			key: 'homeZone',
			className:
				'max-w-[400px] border-r-0 whitespace-nowrap md:whitespace-normal break-words',
		},
		{
			title: t('functionaryType'),
			dataIndex: 'functionaryType',
			width: 150,
			className: 'whitespace-nowrap',
			render: (__, record) => {
				let functionaryTypeValue = '';
				switch (true) {
					case record.isApprover:
						functionaryTypeValue = 'Approver';
						break;
					case record.isZC:
						functionaryTypeValue = 'ZC';
						break;
					case record.isCareTeam:
						functionaryTypeValue = 'Care Team';
						break;
					case record.isPreworkAdmin:
						functionaryTypeValue = 'Prework Admin';
						break;
					case record.isNpsAdmin:
						functionaryTypeValue = 'NPS Admin';
						break;
					case record.isScreeningAdmin:
						functionaryTypeValue = 'Screening Admin';
						break;
					default:
						functionaryTypeValue = 'Proposer';
				}
				return <span>{functionaryTypeValue}</span>;
			},
		},
		{
			title: t('action'),
			key: 'operation',
			fixed: 'right',
			width: 150,
			render: (__, record) => (
				<Button
					className={`hidden sm:block font-sans font-bold text-sm border border-solid mt-0.5 text-primary-blue border-primary-blue w-[129px]`}
					variant="outlined"
					onClick={() => handleEditProposerClick(record)}
				>
					{t('editOrUpdate')}
				</Button>
			),
		},
	];
};
